import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

async function fetchSuggestedSubTopics(search: string) {
  let query = apiClient
    .from('sub_topics')
    .select('id, name, topics ( name )')
    .order('name', { ascending: true })
    .limit(25);

  if (search.trim()) {
    query = query.ilike('name', `%${search.trim()}%`);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
}

export function useGetSuggestedSubTopics(search: string, enabled: boolean = true) {
  return useQuery({
    queryKey: keys.getSuggestedSubTopics(search),
    queryFn: () => fetchSuggestedSubTopics(search),
    staleTime: _3_DAYS,
    enabled,
  });
}
